<div class="content-title" [innerHTML]="content().title | appTranslate | async"></div>
<mat-accordion>
  @for (row of content().rows || []; track row.title) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        {{ row.title | appTranslate | async }}
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="" [innerHTML]="row.text | appTranslate | async"></div>
      </ng-template>
    </mat-expansion-panel>
  }
</mat-accordion>
